module.exports = __webpack_public_path__ + "static/media/user-slash.3de7130d.svg";